import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {TransactionReportingService} from 'app/core/services/transaction-reporting.service';
import {Subscription} from 'rxjs';
import {NotifMessageService} from 'app/core/services/notifmessage.service';
import {WalletByTransaction} from 'app/core/models/walletByTransaction';
import * as moment from "moment";
import {Moment} from "moment";
import {MatDatepicker} from "@angular/material/datepicker";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MerchantService} from "app/core/services/merchant.service";
import {UtilsService} from 'app/core/services/utils.service';


export const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY'
  }
};

interface FormModel {
  chartType: FormControl<string>;
  month: FormControl<Moment>;
}

@Component({
  selector: 'app-payment-transaction-reports',
  templateUrl: './payment-transaction-reports.component.html',
  styleUrls: ['./payment-transaction-reports.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {
      provide: MAT_DATE_FORMATS,
      useValue: MONTH_FORMATS
    },
  ],
})
export class PaymentTransactionReportsComponent implements OnInit {
  isLoading: boolean = true;
  chartType: String = "doughnut";
  month = moment();
  chartTypeSubscription: Subscription;
  monthSubscription: Subscription;
  formGroup: FormGroup<FormModel>;
  report: WalletByTransaction[] = [];
  reportData: number[] = [];
  reportLabel: string[] = [];
  criteria = {
    count: 50,
    windowBegin: null,
    windowEnd: null
  };

  displayedColumns = ['merchantName', 'transactionCount'];

  constructor(
    private formBuilder: FormBuilder,
    private tsxReportingService: TransactionReportingService,
    private notifService: NotifMessageService,
    private merchantService: MerchantService,
    private utils: UtilsService) { }

  ngOnInit(){
    this.formGroup = this.formBuilder.group({
      chartType: new FormControl('doughnut'),
      month: new FormControl(moment())
    });
    this.chartTypeSubscription = this.formGroup.get("chartType").valueChanges.subscribe(val => {
      this.chartType = val;
    });
    this.monthSubscription = this.formGroup.get("month").valueChanges.subscribe(val => {
      if (val) {
        this.month = val;
        if (this.isFormValid) {
          this.refreshReport();
        }
      } else {
        this.clearReport();
      }
    });
    this.refreshReport();
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.getMonthValue();
    ctrlValue.year(normalizedYear.year());
    this.updateMonthValue(ctrlValue)
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.getMonthValue();
    ctrlValue.month(normalizedMonth.month());
    this.updateMonthValue(ctrlValue)
    datepicker.close();
  }

  refreshReport() {
    this.criteria.windowBegin = this.utils.getMonthBegin(this.getMonthValue());
    this.criteria.windowEnd = this.utils.getMonthEnd(this.getMonthValue());
    this.fillReport();
  }

  clearReport() {
    this.report = [];
    this.reportData = [];
    this.reportLabel = [];
  }

  private getMonthValue() {
    return this.formGroup.get('month').value;
  }

  private updateMonthValue(value) {
    this.formGroup.get('month').setValue(value)
  }

  isFormValid(): boolean {
    return this.formGroup.get('month').valid;
  }

  fillReport() {
    this.isLoading = true;
    this.tsxReportingService.getCompletedPaymentTransactionsCountByMerchant(this.criteria).subscribe(
      items => {
        this.clearReport();
        if (items != null && items.length > 0) {
          this.report = items;
          this.merchantService.getMerchantNamesByIds(items.map(o => o.merchantId)).subscribe(
            l => {
              const map: Map<string, string> = new Map(l.map(obj => [obj.id.toString(), obj.name]));
              if (l.length != items.length) {
                this.notifService.notifyWarn('MERCHANT_LIST_IS_INCOMPLETE');
              }
              this.report.forEach((row, index) => {
                row.merchantName = map.get(row.merchantId);
                this.reportLabel[index] = row.merchantName;
              });
            }
          );
          this.reportData = items.map(o => o.transactionCount);
        } else {
          this.notifService.notifyInfo('EMPTY_RESULT');
        }
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    if (this.chartTypeSubscription) {
      this.chartTypeSubscription.unsubscribe();
    }
    if (this.monthSubscription) {
      this.chartTypeSubscription.unsubscribe();
    }
  }

}
